<template>
  <div class="d-flex flex-column flex-fill">

    <div class="d-flex flex-column flex-fill">
      <!-- Single -->
      <div v-if="nowSpecification === 'single'">
        <div class="d-flex flex-column align-items-start p-3 border-bottom">
          <span>【商品性質】</span>
          <div class="d-flex align-items-center pl-3 pt-3">
            <font-awesome-icon :icon="['fas', 'play']" />
            <span class="pl-3">本商品性質：單一規格<small><a href="#"
                  @click.prevent="selectMethod('multiple')">新增多選規格鞋子</a></small></span>
          </div>
          <div class="pl-5">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value='1'
                :checked='thdata.speCheck==1'
                @input='changeinput("speCheck",thdata.speCheck==1?0:1)' id="speCheck" />
              <label class="form-check-label" for="speCheck">同時為商品項目（同步新增商品項目）</label>
            </div>
          </div>
          <div class='w-100'>
            <div class="d-flex align-items-center pl-3 pt-3">
              <font-awesome-icon :icon="['fas', 'play']" />
              <div class="pl-3">組合商品：<span v-if='singleProList.length==0'>無</span> </div>
              <small>
                <b-dropdown size="sm" toggle-tag='a' variant="link"
                  toggle-class="text-decoration-none" no-caret @show="singlesearchshow">
                  <template #button-content>
                    添加現有商品
                  </template>
                  <b-dropdown-form @submit.stop.prevent="() => {}" form-class="mx-1">
                    <b-form-input v-model="singlesearchdata" id="tag-search-input" type="search"
                      size="sm" autocomplete="off" placeholder="找尋項目">
                    </b-form-input>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item-button v-for='(item,$index) in singlesearch.listitem '
                      @click='singlesearchbtn(item)' :key='"AAC__"+item.name+$index'>
                      {{item.code}}-{{item.name}}
                    </b-dropdown-item-button>
                  </b-dropdown-form>
                </b-dropdown>
              </small>
            </div>
            <div class="d-flex align-items-center pl-3 mt-3">
              <b-badge variant="info" v-for='(item,$index) in singleProList'>
                <div class='d-flex align-items-center'>
                  <span class='mr-2'>{{$index+1}}.{{item.code}}-{{item.name}}</span>
                  <b-input type='number' min='0' size='sm' class='text-right p-0'
                    v-model='item.number' style='width:50px;'></b-input>
                  <span>個</span>
                  <span class='cur-print ml-2' style='font-size:16px'
                    @click='singlesearchdelete(item)'>
                    <font-awesome-icon :icon="['fas', 'times-circle']" /></span>
                </div>
              </b-badge>
            </div>
          </div>
        </div>
      </div>

      <!-- multiple Box-->
      <div v-if="nowSpecification === 'multiple'">
        <div class="d-flex flex-column align-items-start p-3 border-bottom">
          <span>【商品性質】</span>
          <div class="d-flex align-items-center pl-3 pt-3">
            <font-awesome-icon :icon="['fas', 'play']" />
            <span class="pl-3">本商品性質：規格模式<small><a href="#"
                  @click.prevent="selectMethod('case')">變更方案</a>／<a href="#"
                  @click.prevent="selectMethod('single')">單一模式</a></small></span>
          </div>
          <div class="text-left pt-3">
            <small>
              以下所有價格自動帶入（1）基本資料－基本價格後，再開始自訂，價格只能設定在第 N 組；[消費相關]優惠期間之折價顯示在優惠價格
            </small>
          </div>
          <div class="d-flex">
            <small>【一般價】 <span class='text-info'>{{basedata.price.base | currency}}</span></small>
            <small class="pl-3">【定價】
              <span class='text-info'>{{basedata.price.sell | currency}}</span></small>
            <small class="pl-3">【成本】 <span
                class='text-info'>{{basedata.price.cost | currency}}</span></small>
          </div>
          <dir>
            <div class='d-flex'>
              <div>第1組選項</div>
              <div></div>
            </div>
            <!-- <tr>
              <td colspan="2"></td>
              <td colspan="2">項目</td>
              <td>選項型態<sup>？</sup></td>
              <td colspan="3">單選</td>
            </tr> -->
          </dir>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th colspan="2">
                  <button type="button" class="btn btn-outline-primary btn-sm"
                    @click='openmultiple("insert")'>新增</button>
                </th>
                <th style='width:200px;'>選項項目</th>
                <th style='width:200px;'>套用消費優惠</th>
                <th style='width:120px;'>一般價</th>
                <th style='width:120px;'>定價</th>
                <th style='width:120px;'>成本價</th>
                <th>備註</th>
              </tr>
            </thead>
            <tbody align="left">
              <tr>
                <td style='width:50px;'>(主)</td>
                <td style='width:90px;'>
                  <div class='d-flex flex-wrap'>
                    <button type="button" class="btn btn-outline-warning btn-sm "
                      @click='editmultiple(basedata,"base")'>
                      <font-awesome-icon class='cur-print' :icon="['fas', 'pen-alt']" />
                    </button>
                    <button type="button" class="btn btn-outline-info btn-sm ml-1"
                      @click='openmultiple(`insert`,basedata)'>
                      <font-awesome-icon class='cur-print' :icon="['fas', 'clone']" />
                    </button>
                  </div>
                </td>
                <td>
                  <span>{{basedata.smallname || basedata.name}}</span>
                </td>
                <td class='text-right'>
                </td>
                <td class='text-right'>{{basedata.price.base |currency}}</td>
                <td class='text-right'>{{basedata.price.sell |currency}}</td>
                <td class='text-right'>{{basedata.price.cost |currency}}</td>
                <td></td>
              </tr>
              <tr v-for='(item,$index) in thdata.multiple.case1' v-if='item.delete!=1'>
                <td style='width:50px;'>
                  <div class='d-flex'>{{$index+1}}
                    <font-awesome-icon class='text-danger cur-print' :icon="['fas', 'trash-alt']"
                      @click='multipleDel(item)' />
                  </div>
                </td>
                <td style='width:90px;'>
                  <div class='d-flex flex-wrap'>

                    <button type="button" class="btn btn-outline-warning btn-sm "
                      @click='editmultiple(item)'>
                      <font-awesome-icon class='cur-print' :icon="['fas', 'pen-alt']" />
                    </button>
                    <button type="button" class="btn btn-outline-info btn-sm ml-1"
                      @click='openmultiple(`insert`,item)'>
                      <font-awesome-icon class='cur-print' :icon="['fas', 'clone']" />
                    </button>
                  </div>
                </td>
                <td>
                  <span>{{item.smallname || item.name}}</span>
                </td>
                <td>
                  <div class='d-flex cur-print'>
                    <label :for='"NUA__"+$index'>適用優惠:</label>
                    <b-form-checkbox :id='"NUA__"+$index' :checked='item.discount==1'
                      @input='item.discount=item.discount==1?0:1'>
                    </b-form-checkbox>
                  </div>
                </td>
                <td class='text-right'>{{item.price.base |currency}}</td>
                <td class='text-right'>{{item.price.sell |currency}}</td>
                <td class='text-right'>{{item.price.cost |currency}}</td>
                <td></td>
              </tr>

            </tbody>
          </table>
          <dir>
            <div class='d-flex'>
              <div class='px-2'>第2組選項</div>
            </div>
          </dir>
          <table class="table table-bordered">
            <colgroup>
              <col style='width:60px;' />
              <col style='width:80px;' />
            </colgroup>
            <thead>
              <tr>
                <th class='text-center' style='width:80px;' colspan="2">
                  <button type="button" class="btn btn-outline-primary btn-sm"
                    @click='openmultipleCase("insert")'>新增</button>
                </th>
                <th style='width:300px'>選項項目</th>
                <th style='width:100px'>價錢調整</th>
                <th style='width:100px'>調整金額</th>
                <th></th>
              </tr>
            </thead>
            <tbody align="left">
              <tr v-for='(item,$index) in thdata.multiple.case2' v-if='item.delete!=1'>
                <th class='text-center'>
                  <div>
                    {{$index+1}}
                    <font-awesome-icon class='text-danger cur-print' :icon="['fas', 'trash-alt']"
                      @click='multipleC2Del(item)' />
                  </div>
                </th>
                <th style='width:100px;'>
                  <div class='d-flex flex-wrap'>
                    <button type="button" class="btn btn-outline-warning btn-sm "
                      @click='editmultipleC2(item)'>
                      <font-awesome-icon class='cur-print' :icon="['fas', 'pen-alt']" />
                    </button>
                    <button type="button" class="btn btn-outline-info btn-sm ml-1"
                      @click='openmultiple(`insert`,item)'>
                      <font-awesome-icon class='cur-print' :icon="['fas', 'clone']" />
                    </button>
                  </div>
                </th>
                <td>{{item.name}}</td>
                <td>{{pricemethod |filter({value:item.pricemethod})[0].name}}</td>
                <td>
                  {{pricemethod |filter({value:item.pricemethod})[0].asname}}{{item.price |currency}}
                </td>
                <th></th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="nowSpecification === 'case'">
        <div class="d-flex flex-column align-items-start p-3 border-bottom">
          <span>【商品性質】</span>
          <div class="d-flex align-items-center pl-3 pt-3">
            <font-awesome-icon :icon="['fas', 'play']" />
            <span class="pl-3">本商品性質：方案模式<small><a href="#"
                  @click.prevent="selectMethod('multiple')">變更為規格</a>／<a href="#"
                  @click.prevent="selectMethod('single')">單一模式</a></small></span>
          </div>

          <div class="text-left pt-3">
            <small>
              以下所有價格自動帶入（1）基本資料－基本價格後，再開始自訂；[消費相關]優惠期間之折價顯示在優惠價格
            </small>
          </div>
          <div class="d-flex">
            <small>【一般價】 <span class='text-info'>{{basedata.price.base | currency}}</span></small>
            <small class="pl-3">【定價】
              <span class='text-info'>{{basedata.price.sell | currency}}</span></small>
            <small class="pl-3">【成本】 <span
                class='text-info'>{{basedata.price.cost | currency}}</span></small>
          </div>
          <div>
            {{thdata.synele}}
            <b-form-checkbox :checked="thdata.synele==1"
              @input='changeinput("synele",(thdata.synele==1?0:1))'>
              （主）商品包含項目，同步套用至方案內
            </b-form-checkbox>
          </div>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th colspan="2" class='text-center'>
                  <button type="button" class="btn btn-outline-primary btn-sm"
                    @click='editCase("","insert")'>新增</button>
                </th>
                <td> 方案名稱 </td>
                <td> 商品包含項目 </td>
                <td> 目前優惠 </td>
                <td> 一般價 </td>
                <td> 定價 </td>
                <td> 成本價 </td>
                <td></td>
              </tr>
            </thead>
            <tbody align="left" style="vertical-middle">
              <tr>
                <th class='text-center'>（主）</th>
                <td class='text-center'>
                  <button type="button" class="btn btn-outline-warning btn-sm"
                    @click='editCase(basedata,"update","base")'>編輯</button>
                </td>
                <td>
                  {{basedata.name}}
                </td>
                <td>
                  <b-badge variant="primary" v-for='ii in basedata.element'>
                    {{ii.name}}*{{ii.number}}
                  </b-badge>
                </td>
                <td>
                  {{caseItemNowPrice(insCostdata.period)}}
                </td>
                <td class='text-right'>
                  {{basedata.price.base |currency}}
                </td>
                <td class='text-right'>
                  {{basedata.price.sell |currency}}
                </td>
                <td class='text-right'>
                  {{basedata.price.cost |currency}}
                </td>
                <td></td>
              </tr>
              <tr v-for='(item,$index) in thdata.casemethod'>
                <th class='text-center'>{{$index+1}}</th>
                <td class='text-center'>
                  <button type="button" class="btn btn-outline-warning btn-sm"
                    @click='editCase(item,"update")'>編輯</button>
                </td>
                <td>
                  {{item.name}}
                </td>
                <td>

                  <b-badge variant="primary" v-for='ii in item.element'>{{ii.name}}*{{ii.number}}
                  </b-badge>
                  <!-- {{item.element}} -->
                </td>
                <td>
                  {{caseItemNowPrice(item.period)}}
                </td>
                <td class='text-right'>
                  {{item.price.base |currency}}
                </td>
                <td class='text-right'>
                  {{item.price.sell |currency}}
                </td>
                <td class='text-right'>
                  {{item.price.cost |currency}}
                </td>
                <td></td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="d-flex flex-column align-items-start p-3">
        <span>【整體設定】</span>
        <div class="d-flex align-items-center">
          <span>本商品單次可購買數量：</span>
          <b-select :value="thdata.maxnumber.method" style='width:80px;'
            @input='changeinput("method",$event,"maxnumber")'>
            <option value="">無</option>
            <option :value="item.value" v-for='item in maxmethodlist'>
              {{item.name}}
            </option>
          </b-select>

          <div style="width:60px;" v-if='thdata.maxnumber.method'>
            <b-input type='number' min='0' class='text-right' :value="thdata.maxnumber.number"
              @input='changeinput("number",$event,"maxnumber")'></b-input>
          </div>
          <span v-if='thdata.maxnumber.method'> 筆</span>
        </div>
      </div>
    </div>
    <!-- multiple Case2 Box -->
    <b-modal v-model='multipledata.open' @ok='multipleok()'>
      <template #modal-header>
        <h4>項目-{{multipledata.method=="insert"?'新增':'修改'}}</h4>
      </template>
      <template>
        <div>
          <div class="d-flex align-items-center ">
            <label class='px-2 text-nowrap'>項目全名</label>
            <b-input v-model='multipledata.name'></b-input>
          </div>
          <div class="d-flex align-items-center mt-2">
            <label class='px-2 text-nowrap'>項目短名</label>
            <b-input v-model='multipledata.smallname'></b-input>
          </div>
          <div class='d-flex justify-content-around align-items-center mt-2'>
            <div class="d-flex align-items-center">
              <label class='px-2 text-nowrap'>一般價錢</label>
              <b-input type='number' min='0' class='text-right' v-model='multipledata.price.base'>
              </b-input>
            </div>
            <div class="d-flex align-items-center">
              <label class='px-2 text-nowrap'>定價</label>
              <b-input type='number' min='0' class='text-right' v-model='multipledata.price.sell'>
              </b-input>
            </div>
            <div class="d-flex align-items-center">
              <label class='px-2 text-nowrap'>成本價</label>
              <b-input type='number' min='0' class='text-right' v-model='multipledata.price.cost'>
              </b-input>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer='{ok,close}'>

        <button class='btn btn-outline-primary' @click='ok()'>儲存</button>
        <button class='btn btn-outline-danger' @click='close()'>關閉</button>
      </template>
    </b-modal>
    <!-- multiple Case2 Box-->
    <b-modal v-model='multipleCase2.open' @ok='multipleC2ok()'>
      <template #modal-header>
        <h4>項目2-{{multipleCase2.method=="insert"?'新增':'修改'}}</h4>
      </template>
      <template>
        <div>
          <div class="d-flex align-items-center ">
            <div class='px-2 text-nowrap' style='width:100px;'>項目2名稱</div>
            <b-input v-model='multipleCase2.name'></b-input>
          </div>

          <div class="d-flex align-items-center mt-2">
            <div class='px-2 text-nowrap' style='width:100px;'>調整價錢</div>
            <b-form-radio-group v-model="multipleCase2.pricemethod" name="multipleC2Mt">
              <b-form-radio v-for='item in pricemethod' :value='item.value'>{{item.name}}
              </b-form-radio>
            </b-form-radio-group>
          </div>
          <div class="d-flex align-items-center mt-2 ">
            <div class='px-2 text-nowrap' style='width:80px;'>價錢</div>
            <span>{{pricemehtod}}$</span>
            <div style='width:80px;'>
              <b-input v-model='multipleCase2.price' type='number' min='0' class='text-right'>
              </b-input>
            </div>
            <span>NT</span>
          </div>
        </div>
      </template>
      <template #modal-footer='{ok,close}'>

        <button class='btn btn-outline-primary' @click='ok()'>儲存</button>
        <button class='btn btn-outline-danger' @click='close()'>關閉</button>
      </template>
    </b-modal>
    <!-- Case Box -->
    <b-modal v-model='caseBox.open' @ok='caseBoxok()' size="xl">
      <template #modal-header>
        <h4>方案-{{caseBox.method=="insert"?'新增':'修改'}}</h4>
      </template>
      <template>
        <div>
          <div class="d-flex align-items-center ">
            <div class='px-2 text-nowrap' style='min-width:100px;'>方案名稱</div>
            <b-input v-model='caseBox.name'></b-input>
          </div>
          <div class="d-flex align-items-center mt-2 ">
            <div class='px-2 text-nowrap' style='min-width:100px;'>制定價錢</div>
            <b-input-group size class="flex-fill mb-0" :class="{'pr-md-1':((key+1) < 3)}"
              v-for="(i,key) in priceKid" :key='"PriceKid__"+i.field'>
              <template v-slot:prepend>
                <b-input-group-text>{{i.name}}$</b-input-group-text>
              </template>
              <b-form-input type="number" class="text-right" v-model='caseBox.price[i.field]'>
              </b-form-input>
            </b-input-group>
          </div>
          <div class="d-flex align-items-center mt-2 ">
            <div class='px-2 text-nowrap' style='min-width:100px;'>包含項目</div>
            <div>
              <button type='button' class='btn btn-sm btn-primary'>新增項目</button>
            </div>
            <div class='flex-fill'>
              <div class='d-flex'>
                <b-dropdown id="dropdown-1" class="m-md-2" size='sm' menu-class="w-100">
                  <template #button-content>選擇加入項目</template>
                  <b-dropdown-form @submit.stop.prevent="() => {}" form-class="mx-1">
                    <b-form-input v-model="elementsearchdata" id="tag-search-input" type="search"
                      size="sm" autocomplete="off" placeholder="找尋項目">
                    </b-form-input>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item-button v-for='item in caseBox.elementsearch.listitem'
                      @click='elementsearchbtn(item)'>
                      {{item.name}}
                    </b-dropdown-item-button>
                  </b-dropdown-form>
                </b-dropdown>
                <ul class="list-inline d-inline-block mb-2 mt-2">
                  <li v-for="tag in caseBoxElement" :key="tag.uid" class="list-inline-item">
                    <b-badge variant="info">
                      <div class='d-flex align-items-center'>
                        <span class='mr-1'>{{tag.code}}-{{tag.name}}</span>
                        <b-input type='number' min='0' v-model='tag.number' class='text-right'
                          size='sm' style='width:60px;' />
                        <span>個</span>
                        <span class='cur-print ' style='font-size:16px'
                          @click='elementsearchdelete(tag)'>
                          <font-awesome-icon :icon="['fas', 'times-circle']" /></span>
                      </div>
                    </b-badge>
                    <!-- <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled"
                        variant="info" :pill='true' size="sm">{{ tag }}</b-form-tag> -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class='w-100' v-if='caseBox.method=="insert"'>
            <small></small>
          </div>
          <div class="mt-2">
            <h5 class='px-2 text-nowrap text-info'><b>優惠方案設定</b></h5>
            <div>
              <betweenPrice :baseData='caseBox' :thdata='caseBox'></betweenPrice>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer='{ok,close}'>
        <button class='btn btn-outline-primary' @click='ok()'>儲存</button>
        <button class='btn btn-outline-danger' @click='close()'>關閉</button>
      </template>
    </b-modal>
  </div>
  <!-- <div class="d-flex flex-column h-100">
    <div class="d-flex text-left">
      <ul>
        <li>可針對某個規格輸入規格價格 ( 一般價、會員價、成本價 )</li>
        <li>沒輸入規格價格 時，表示沿用 [基本欄位] 中所設定的價格</li>
        <li>規格價格 僅能設定於某組單選上</li>
        <li>規格庫存 僅能設定於第 1 組單選上</li>
      </ul>
    </div>
    <div class="d-flex">
      <table class="table">
        <thead>
          <tr>
            <th></th>
            <th>規格名稱</th>
            <th>型態</th>
            <th>規格選項</th>
            <th>規格庫存</th>
            <th>一般價(元)</th>
            <th>會員價(元)</th>
            <th>成本價(元)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in num" :key="index">
            <td>
              第{{ index + 1 }}組
              <div
                v-if="item.type === 'bigtextarea'"
                class="d-flex flex-wrap text-left"
                style="width:350px"
              >
                ※ 消費者於大文字框內輸入的文字，於銷售統計規格時不會列入統計
              </div>
            </td>
            <td align="center">
              <b-form-input v-model="item.speName" size="sm" style="width:100px"></b-form-input>
            </td>
            <td>
              <select class="custom-select" id="inputGroupSelect01" v-model="item.type">
                <option value="SingleCheck" selected>單選</option>
                <option value="dropdown">下拉</option>
                <option value="check">複選</option>
                <option value="textarea">文字框</option>
                <option value="bigtextarea">大文字框</option>
              </select>
            </td>
            <template v-if="item.type === 'SingleCheck'">
              <td align="center">
                <div class="d-flex flex-column">
                  <div v-for="(j, index2) in item.count.length" :key="index2">
                    <b-form-input v-model="item.spe[index2]" size="sm"> </b-form-input>
                  </div>
                  <a href @click.prevent="addNum(index)">新增選項</a>
                </div>
              </td>
              <td align="center">
                <div class="d-flex flex-column tdinput">
                  <div v-for="(j, index2) in item.count.length" :key="index2">
                    <b-form-input v-model="item.stock[index2]" size="sm"> </b-form-input>
                  </div>
                </div>
              </td>
              <td align="center">
                <div class="d-flex flex-column tdinput">
                  <b-form-input
                    v-for="(j, index2) in item.count.length"
                    :key="index2"
                    v-model="item.normalp[index2]"
                    size="sm"
                  >
                  </b-form-input>
                </div>
              </td>
              <td align="center">
                <div class="d-flex flex-column tdinput">
                  <b-form-input
                    v-for="(j, index2) in item.count.length"
                    :key="index2"
                    v-model="item.memberp[index2]"
                    size="sm"
                  >
                  </b-form-input>
                </div>
              </td>
              <td align="center">
                <div class="d-flex flex-column tdinput">
                  <b-form-input
                    v-for="(j, index2) in item.count.length"
                    :key="index2"
                    v-model="item.costp[index2]"
                    size="sm"
                  >
                  </b-form-input>
                </div>
              </td>
            </template>
            <template v-else-if="item.type === 'dropdown'">
              <td colspan="5" align="center">
                <div class="d-flex">
                  <textarea class="form-control" rows="5" style="width:600px"></textarea>
                </div>
              </td>
            </template>
            <template v-else-if="item.type === 'check'">
              <td align="center">
                <div class="d-flex flex-column">
                  <div v-for="(j, index2) in item.count.length" :key="index2">
                    <b-form-input v-model="item.spe[index2]" size="sm"> </b-form-input>
                  </div>
                  <a href @click.prevent="addNum(index)">新增選項</a>
                </div>
              </td>
            </template>
            <template v-else-if="item.type === 'textarea'">

            </template>
          </tr>
        </tbody>
        <a href="" @click.prevent="addTr()">新增一組規格</a>
      </table>
    </div>
    <div class="d-flex flex-row h-100 border">
      <div class="d-flex border-right align-items-center">規定購買數量</div>
      <div class="d-flex flex-column text-left flex-fill">
        <b-form-input size="sm" style="width:500px"></b-form-input>
        <ul>
          <li>
            輸入 10;20;30 表示購買單位必須是 10;20;30 件 ( 例如：鈕扣：一個單位是10顆，不可以零買3顆
            )
          </li>
          <li>輸入＞10 表示最少需買10(含)件以上</li>
          <li>輸入＜3 表示單張訂單內最多只能買3(含)件，適用：跳樓特價品</li>
        </ul>
      </div>
    </div>
  </div> -->
</template>
<script>
  import ctrl from "./insSpecification.js";
  export default ctrl;

</script>
<style lang="scss">
  .tdinput {
    width: 60px;
  }

</style>
